<template>
    <div class="title-wrapper">
        <h2 class="title">
            <slot name="title">Default Title</slot>
        </h2>
    </div>
</template>

<script>
export default {
};
</script>

<style scoped>
    .title{
        text-transform: uppercase;
        font-size: 22px;
    }
</style>
